export const Settings = {
  AV_CHECKIN_INTERVAL: 5 * 60 * 1000,
  FLEX_TIME_FOR_TIMELINE_IN_SECONDS: 10 * 60,
  MAX_FRONTEND_GAP_TO_BE_PRESENT_IN_SECONDS: 5 * 60,
  PRESENCE_CHECK_IN_INTERVAL: 1 * 60 * 1000,
  PUBSUB_PING_INTERVAL: 1 * 30 * 1000,
  PUBSUB_STATS_COLLECTION_INTERVAL: 2 * 60 * 1000,
  SIDEBAR_CONTENT_WIDTH: 288,
  SIDEBAR_CONTROLS_WIDTH: 36,

  // Monitoring settings
  PUBSUB_PING_DANGER_THRESHOLD: 275,
  PUBSUB_PING_WARNING_THRESHOLD: 200,
};
